/**
 * TanStack Query hooks for `affiliate-tiers`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	affiliateTiersQueryKeys,
	type CreateAffiliateTierBody,
	type CreateAffiliateTierResponse,
	type DeleteAffiliateTierResponse,
	type ListAffiliateTiersResponse,
} from "./api";

export function useAffiliateTiersList(): UseQueryResult<
	ListAffiliateTiersResponse,
	Error
> {
	return useQuery({
		queryKey: affiliateTiersQueryKeys.list(),
		queryFn: list,
	});
}

export function useAffiliateTiersCreate(): UseMutationResult<
	CreateAffiliateTierResponse,
	Error,
	CreateAffiliateTierBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: affiliateTiersQueryKeys.all });
		},
	});
}

export function useAffiliateTiersDelete(): UseMutationResult<
	DeleteAffiliateTierResponse,
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: affiliateTiersQueryKeys.all });
		},
	});
}
